<template>
  <div>

    <mytable
      :tableColums='tableColums_getQuestionTopicTypeList'
      api='getQuestionTopicTypeList'
      xupdateapi='updateBusinessAttr'
      :height="H-165" >
    </mytable> 
  </div>
</template>

<script>
export default {
  data() {
    return {
      attrId: null,

      tableColums_getQuestionTopicTypeList: {
        $selection: false,

        qttName: '类型名称',
        qttScoreDefault: '默认分数',

        canDelete: ['状态',,"@v-if: 1:允许删除#success, 2:不允许删除#danger",],

      },

    };
  },

  watch: {
    
  },

  methods: {},

  created() {
    this.getQuestionTopicTypeList();
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/paper/TopicTypeManage.vue